import {
  base_colorActionHover,
  green300,
  grey500,
  red300,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  font-family: ${font_family_weight_regular};

  & .wrapper {
    width: 100%;
    padding: ${spacing(2)};
    border: 1px solid transparent;
    border-radius: ${spacing(1)};
    cursor: pointer;

    overflow: hidden;
    font-family: ${font_family_weight_regular};

    &:hover {
      border-color: ${grey500};
    }

    &:focus {
      border-color: ${base_colorActionHover};
      outline: none;
    }

    &.disabled {
      border-color: transparent !important;
      cursor: not-allowed;
    }

    /* tight click area: wrapper itself is not the click target;
       hover/focus borders move to the tight text-container instead */
    &.tight-click-area {
      cursor: default;
      &:hover,
      &:focus {
        border-color: transparent;
      }
      & .text-container {
        max-width: fit-content;
        cursor: pointer;
        border: 1px solid transparent;
        border-radius: ${spacing(1)};
        padding: ${spacing(1)} ${spacing(2)};
        margin: -${spacing(1)} -${spacing(2)};
        &:hover {
          border-color: ${grey500};
        }
        &:focus {
          border-color: ${base_colorActionHover};
          outline: none;
        }
      }
    }
  }

  & .text-container {
    max-width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${spacing(1)};
    overflow: hidden;

    .text {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      flex: 1;

      ${font_md};
      color: ${text_colorTextPrimary};

      &.highlight {
        color: ${green300};
      }
      &.severe {
        color: ${red300};
      }
    }

    .icons-container {
      height: 18px;
      display: flex;
      align-items: center;
      align-self: flex-end;
    }

    .icon {
      background: transparent;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;

      align-self: flex-end;
      width: 16px;
      height: 16px;
    }

    &.bold {
      font-family: ${font_family_weight_medium};
    }

    &.alignRight {
      text-align: end;
    }

    .subtext {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      ${font_sm};
      color: ${text_colorTextSecondary};

      &.highlight {
        color: ${green300};
      }
      &.severe {
        color: ${red300};
      }
    }
  }
`
